module.exports = __webpack_public_path__ + "static/media/Manual TP-Link.479a0bd7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual TP-Link.pdf
// module id = 320
// module chunks = 0